export default {
  UPDATE_SAVED_SEARCH: 'UPDATE_SAVED_SEARCH',
  CLEAR_SAVED_SEARCH: 'CLEAR_SAVED_SEARCH',
}
